import { Controller } from '@hotwired/stimulus'
import '../../../css/log/log.scss'
import '../../entrypoints/modules/semantic-ui-dropdown'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'
import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css'
import { getTimeFormat } from '../../utils/utils'
import { configureCancellableDateTimePicker } from '../../utils/dateTimePicker'
import { dispatchCustomEvent } from '../../modules/utils/DispatchCustomEvent'
import {
  trans,
  PLURAL_DAYS,
  PLURAL_HOURS,
  PLURAL_MINUTES
} from '../../translator'

/* global accountIsUseAmPm */

global.moment = require('moment')
require('tempusdominus-bootstrap-4')
$.fn.datetimepicker.Constructor.Default = $.extend(
  {},
  $.fn.datetimepicker.Constructor.Default,
  {
    icons: {
      time: 'far fa-clock',
      date: 'far fa-calendar',
      up: 'far fa-arrow-up',
      down: 'far fa-arrow-down',
      previous: 'far fa-chevron-left',
      next: 'far fa-chevron-right',
      today: 'far fa-calendar-check-o',
      clear: 'far fa-trash',
      close: 'far fa-check'
    }
  }
)

export default class extends Controller {
  static targets = [
    'logEventSelect',
    'logEventMenu',
    'logEventMarkerSelect',
    'logRelativeEventSelect',
    'logRelativeEventMenu',
    'logEventTimeSelect',
    'logEventTimeInput',
    'logEventTimeInfo',
    'logRelativeMarkerGroup',
    'logRelativeMarkerInput',
    'incomplete',
    'beforeActivation'
  ]

  get logTimingsController () {
    return this.application.getControllerForElementAndIdentifier(
      this.element.closest('[data-controller="log-timings"]'),
      'log-timings'
    )
  }

  get logController () {
    return this.application.getControllerForElementAndIdentifier(
      this.element.closest('[data-controller="log"]'),
      'log'
    )
  }

  connect () {
    // Log Event Dropdown
    $(this.logEventSelectTarget).dropdown({
      forceSelection: false,
      onChange: (value, text) => {
        this.element.dataset.markerId = value
        dispatchCustomEvent('markers:marker:added', {
          markerId: value,
          markerName: text,
          logMarkerId: this.element.dataset.logMarkerId,
          isApplyToAllDays: document.querySelector('#applyMarkersToAllDaysInput') ? document.querySelector('#applyMarkersToAllDaysInput').checked : false,
          day: this.element.closest('.marker-group').dataset.day
        })

        this.logTimingsController.disableEventDropdownOptions(value)
        this.logTimingsController.enableEventDropdownOptions(
          this.element.dataset.previousMarkerId
        )

        if (value !== this.element.dataset.previousMarkerId) {
          const newItem = '<div class="item" data-value="' + value + '">' + text + '</div>'
          this.logTimingsController.addToRelatedEventDropdowns(value, newItem)
          this.logTimingsController.removeFromRelatedEventDropdowns(
            this.element.dataset.previousMarkerId
          )
          this.logTimingsController.clearRelatedEventDropdowns(
            this.element.dataset.previousMarkerId
          )

          dispatchCustomEvent('markers:marker:removed', {
            markerId: this.element.dataset.previousMarkerId,
            logMarkerId: this.element.dataset.logMarkerId,
            isApplyToAllDays: document.querySelector(
              '#applyMarkersToAllDaysInput'
            )
              ? document.querySelector('#applyMarkersToAllDaysInput').checked
              : false,
            day: this.element.closest('.marker-group').dataset.day
          })

          this.element.dataset.previousMarkerId = value
        }

        this.logTimingsController.calculateAllOccursAt()
      }
    })

    // Marker Type Dropdown (At/Before/After)
    $(this.logEventMarkerSelectTarget).dropdown({
      onChange: (value) => {
        if (value === 'at') {
          this.element.dataset.isAbsolute = true
          this.element.dataset.isRelative = false

          if (this.element.dataset.markerId) {
            this.element.dataset.previousMarkerId = this.element.dataset.markerId
            const newItem =
              '<div class="item" data-value="' + this.element.dataset.markerId + '">' + $(this.logEventSelectTarget).dropdown('get text') + '</div>'
            this.logTimingsController.addToRelatedEventDropdowns(this.element.dataset.markerId, newItem)
          }

          this.hideRelativeMarkerInputs()
          this.showAbsoluteMarkerInputs()
        } else {
          this.element.dataset.isAbsolute = false
          this.element.dataset.isRelative = true

          if (this.element.dataset.markerId) {
            this.element.dataset.previousMarkerId = this.element.dataset.markerId
            const newItem = '<div class="item" data-value="' + this.element.dataset.markerId + '">' + $(this.logEventSelectTarget).dropdown('get text') + '</div>'
            this.logTimingsController.addToRelatedEventDropdowns(this.element.dataset.markerId, newItem)
          }

          if (value === 'after') {
            this.element.dataset.relativeMarkerType = 'after'
          } else if (value === 'before') {
            this.element.dataset.relativeMarkerType = 'before'
          }

          this.hideAbsoluteMarkerInputs()
          this.showRelativeMarkerInputs()
        }

        this.logTimingsController.calculateAllOccursAt()
      }
    })

    $(this.logEventTimeSelectTarget).datetimepicker({
      focusOnShow: false,
      toolbarPlacement: 'bottom',
      format: getTimeFormat(typeof accountIsUseAmPm !== 'undefined' ? accountIsUseAmPm : false),
      buttons: {
        showClose: true,
        showClear: true
      }
    })

    configureCancellableDateTimePicker(
      $(this.logEventTimeSelectTarget),
      'log-marker-' + this.logEventTimeSelectTarget.id,
      (date) => {
        this.showHideAbsoluteMarkerInfo()
        this.calculateOccursAt()
        this.logTimingsController.calculateAllOccursAt(false)
      }
    )

    $(this.logEventTimeSelectTarget).on('hide.datetimepicker', () => {
      if (this.logTimingsController) {
        this.logTimingsController.reorderMarkers()
      }
    })

    this.handleBlur = this.handleBlur.bind(this)
    this.logRelativeMarkerInputTargets.forEach((input) => {
      input.removeEventListener('blur', this.handleBlur)
      input.addEventListener('blur', this.handleBlur)
    })

    $(this.logRelativeEventSelectTarget).dropdown({
      forceSelection: false,
      onChange: (value) => {
        if (value) {
          this.element.dataset.relativeMarkerId = value
        } else {
          delete this.element.dataset.relativeMarkerId
        }
        this.logTimingsController.calculateAllOccursAt()
      }
    })
  }

  disconnect () {
    // Clean up event listeners
    this.logRelativeMarkerInputTargets.forEach((input) => {
      input.removeEventListener('blur', this.handleBlur)
    })

    // Clean up DateTimePicker listeners to prevent memory leaks or zombie events
    $(this.logEventTimeSelectTarget).off('hide.datetimepicker')
  }

  handleBlur (event) {
    const unitKeys = {
      plural_days: PLURAL_DAYS,
      plural_hours: PLURAL_HOURS,
      plural_minutes: PLURAL_MINUTES
    }
    const input = event.target
    const value = parseInt(input.value) || 0
    if (value < input.min) {
      input.value = input.min
    } else if (value > input.max) {
      input.value = input.max
    }

    const unitElement = input.nextElementSibling
    const unitName = unitElement.dataset.localiseKey
    const unitKey = unitKeys[unitName]
    unitElement.textContent = trans(unitKey, { '%count%': value }, 'logs')

    this.logTimingsController.calculateAllOccursAt()
  }

  calculateOccursAt () {
    delete this.element.dataset.occursAtInMinutes

    if (this.element.dataset.isAbsolute === 'true') {
      const inputVal = this.logEventTimeSelectTarget.querySelector(
        'input.datetimepicker-input'
      ).value
      if (inputVal) {
        const dateObj = $(this.logEventTimeSelectTarget).datetimepicker('viewDate')
        const hours = dateObj.hours()
        const minutes = dateObj.minutes()
        this.element.dataset.occursAtInMinutes = hours * 60 + minutes
      }
    } else if (this.element.dataset.isRelative === 'true') {
      const invert =
        this.element.dataset.relativeMarkerType === 'before' ? -1 : 1
      const [relativeDays, relativeHours, relativeMinutes] =
        this.logRelativeMarkerInputTargets.map(
          (target) => (parseInt(target.value) || 0) * invert
        )

      const daysInMinutes = relativeDays * 24 * 60
      const hoursInMinutes = relativeHours * 60
      this.element.dataset.relativeOffsetInMinutes =
        daysInMinutes + hoursInMinutes + relativeMinutes

      if (this.element.dataset.relativeMarkerId) {
        const initialTotalMinutes =
          this.logTimingsController.getAbsoluteTimeInMinutes(
            this.element.dataset.relativeMarkerId
          )
        if (initialTotalMinutes !== null) {
          this.element.dataset.occursAtInMinutes =
            initialTotalMinutes +
            parseInt(this.element.dataset.relativeOffsetInMinutes)
        }
      }
    }

    if (
      this.element.dataset.markerId &&
      this.element.dataset.occursAtInMinutes
    ) {
      this.element.classList.remove('error')
      this.incompleteTarget.classList.add('d-none')
      this.beforeActivationTarget.classList.add('d-none')
    }
  }

  hideAbsoluteMarkerInputs () {
    this.logEventTimeSelectTarget.classList.add('d-none')
    this.logEventTimeSelectTarget.classList.remove('d-inline')
    if (this.hasLogEventTimeInfoTarget) {
      this.logEventTimeInfoTarget.classList.add('d-none')
    }
  }

  showAbsoluteMarkerInputs () {
    this.logEventTimeSelectTarget.classList.add('d-inline')
    this.logEventTimeSelectTarget.classList.remove('d-none')
    this.showHideAbsoluteMarkerInfo()
  }

  showHideAbsoluteMarkerInfo () {
    if (this.logEventTimeSelectTarget.querySelector('input').value) {
      if (this.hasLogEventTimeInfoTarget) {
        this.logEventTimeInfoTarget.classList.add('d-none')
      }
    } else {
      if (this.hasLogEventTimeInfoTarget) {
        this.logEventTimeInfoTarget.classList.remove('d-none')
      }
    }
  }

  hideRelativeMarkerInputs () {
    this.logRelativeMarkerGroupTarget.classList.add('d-none')
    this.logRelativeMarkerGroupTarget.classList.remove('d-inline')
    this.logRelativeEventSelectTarget.classList.add('d-none')
    this.logRelativeMarkerInputTargets.forEach((input) => {
      input.value = null
    })
  }

  showRelativeMarkerInputs () {
    this.logRelativeMarkerGroupTarget.classList.add('d-inline')
    this.logRelativeMarkerGroupTarget.classList.remove('d-none')
    this.logRelativeEventSelectTarget.classList.remove('d-none')
  }

  remove () {
    this.logTimingsController.removeFromRelatedEventDropdowns(
      $(this.logEventSelectTarget).dropdown('get value')
    )
    const absoluteMarkerId = $(this.logEventSelectTarget).dropdown('get value')
    if (absoluteMarkerId) {
      this.logTimingsController.clearRelatedEventDropdowns(absoluteMarkerId)
    }
    this.logTimingsController.enableEventDropdownOptions(
      $(this.logEventSelectTarget).dropdown('get value')
    )

    dispatchCustomEvent('markers:marker:removed', {
      markerId: this.element.dataset.markerId,
      logMarkerId: this.element.dataset.logMarkerId,
      isMarkerRowRemoved: true,
      isApplyToAllDays: document.querySelector('#applyMarkersToAllDaysInput')
        ? document.querySelector('#applyMarkersToAllDaysInput').checked
        : false,
      day: this.element.closest('.marker-group').dataset.day
    })
    this.element.remove()
  }
}
